import { DashboardLayout } from "@/components/layout/DashboardLayout";
import CompetitionManager from "@/components/admin/CompetitionManager";

export default function AdminCompetitions() {
  return (
    <DashboardLayout>
      <CompetitionManager />
    </DashboardLayout>
  );
}